export const CONTENT_REFERENCE_PATTERN = /\{\{\s*content:([A-Za-z0-9_.:-]+)\s*\}\}/g;

export function createContentReferenceToken(sectionName) {
  return `{{content:${String(sectionName || '').trim()}}}`;
}

export function hasContentReferences(value) {
  return new RegExp(CONTENT_REFERENCE_PATTERN).test(String(value || ''));
}

export function extractContentReferenceKeys(value) {
  const text = String(value || '');
  const keys = [];
  const pattern = new RegExp(CONTENT_REFERENCE_PATTERN);
  let match = pattern.exec(text);

  while (match) {
    keys.push(match[1].trim());
    match = pattern.exec(text);
  }

  return [...new Set(keys)];
}

function referencePlaceholder(key, reason, editMode) {
  return editMode ? `[${reason}: ${key}]` : '';
}

export function resolveContentReferences(value, resolveKey, options = {}) {
  const {
    currentKey = '',
    editMode = false,
    visited = new Set(),
    depth = 0,
    maxDepth = 8,
  } = options;

  if (value == null) return '';

  const text = String(value);
  if (!hasContentReferences(text)) return text;
  if (depth > maxDepth) {
    return referencePlaceholder(currentKey || 'unknown', 'content reference depth limit', editMode);
  }

  const activeVisited = new Set(visited);
  if (currentKey) activeVisited.add(currentKey);

  return text.replace(CONTENT_REFERENCE_PATTERN, (match, rawKey) => {
    const key = rawKey.trim();
    if (!key) return '';

    if (activeVisited.has(key)) {
      return referencePlaceholder(key, 'circular content reference', editMode);
    }

    const referencedValue = resolveKey(key);
    if (referencedValue == null) {
      return referencePlaceholder(key, 'missing content reference', editMode);
    }

    return resolveContentReferences(referencedValue, resolveKey, {
      currentKey: key,
      editMode,
      visited: activeVisited,
      depth: depth + 1,
      maxDepth,
    });
  });
}

